<div class="header">
  <div class="title">承認依頼</div>
</div>

<mat-dialog-content class="dialog-content">

  <div class="content-header">
    <div class="description">
      承認者は5名まで選択できますが、そのうちの1名が承認すればフローは進捗します。
    </div>

    <button
      mat-raised-button
      class="select-btn"
      (click)="onSelectApprovers()">

      承認者を選択

    </button>
  </div>

  @if (approvers.length > 0) {

    <div class="approver-list-container">

      <div class="approver-list">

        @for (approver of approvers; track approver.id; let last = $last) {

          <div class="approver-item">

            <div class="approver-header">

              <div class="approver-name">
                {{ approver.position }}
                {{ approver.name }}
              </div>

              <div class="vendor-delete">
                <button
                  class="remove-btn"
                  (click)="removeApprover(approver)">
                  × 削除
                </button>
              </div>

            </div>

            <div class="approver-affiliations">

              @for (affiliation of approver.affiliations; track $index) {

                <div class="affiliation-row">
                  <span class="dot">・</span>
                  {{ affiliation }}
                </div>

              }

            </div>

          </div>

          @if (!last) {
            <mat-divider></mat-divider>
          }

        }

      </div>

    </div>

  }

</mat-dialog-content>

<mat-dialog-actions align="end" class="actions-content">

  @if (isSubmitting) {
    <mat-spinner diameter="28" class="spinner"></mat-spinner>
  }

  <button
    mat-raised-button
    mat-dialog-close>

    キャンセル

  </button>

  <button
    mat-raised-button
    class="yes-btn"
    (click)="onSubmit()"
    [disabled]="!canSubmit">

    送信

  </button>

</mat-dialog-actions>
